import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const OFFER_DURATION_SECONDS = 15 * 60;
export function TopBanner() {
  const [secondsRemaining, setSecondsRemaining] = useState(OFFER_DURATION_SECONDS);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const updateScrollState = () => {
      const nextIsScrolled = window.scrollY > 50;
      setIsScrolled(current => current === nextIsScrolled ? current : nextIsScrolled);
    };
    updateScrollState();
    window.addEventListener('scroll', updateScrollState, {
      passive: true
    });
    return () => window.removeEventListener('scroll', updateScrollState);
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsRemaining(current => current === 0 ? OFFER_DURATION_SECONDS : current - 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  const currentDate = new Date().toLocaleDateString('es-AR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
  return <div className="sticky left-0 right-0 top-0 z-[70] border-b border-[#ec4899]/20 bg-[#1a0b2e]/90 px-4 py-2 text-white shadow-[0_4px_20px_rgba(236,72,153,0.2)] backdrop-blur-sm" data-id="element-236" data-mp="238h2jgj4tmw0">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4" data-id="element-237" data-mp="1u8ax8hxl7t7x">
        <div className="flex items-center gap-3 overflow-hidden" data-id="element-238" data-mp="1p9hfuef6ji2h">
          <AnimatePresence mode="wait" data-id="element-239" data-mp="1p7wo0wk92d8b">
            {!isScrolled && <motion.div initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -10
          }} transition={{
            duration: 0.18
          }} className="flex shrink-0 items-center gap-[6px] text-[8px] md:text-[10px]" data-id="element-240" data-mp="1kbfxjvpkvms2">
                <span className="whitespace-nowrap rounded bg-[#ec4899] px-2 py-0.5 text-[9px] font-black text-white shadow-[0_0_10px_rgba(236,72,153,0.5)] md:text-[10px]" data-id="element-241" data-mp="39pukqbky71lg">
                  OFERTA LANZAMIENTO:
                </span>
                <span className="whitespace-nowrap text-[8px] font-black text-white/90 md:text-[10px]" data-id="element-242" data-mp="y1zfufks3lg1">
                  {currentDate}
                </span>
              </motion.div>}
          </AnimatePresence>

          <div className={`flex shrink-0 items-center gap-1.5 transition-all duration-200 md:gap-2 ${isScrolled ? 'mx-auto' : 'ml-auto md:ml-0'}`} data-id="element-243" data-mp="1qqdduvbvahrl">
            <div className="flex items-center gap-1 text-white/70" data-id="element-244" data-mp="1hpyrrtr2wyn1">
              <Timer className="h-3.5 w-3.5 text-[#00f0ff]" data-id="element-245" data-mp="1hpozfzikafe6" />
              <span className="hidden whitespace-nowrap text-[9px] font-black tracking-widest sm:inline" data-id="element-246" data-mp="1lqsdqhkyo3da">
                LA OFERTA TERMINA EN:
              </span>
            </div>
            <div className="flex gap-0.5 rounded border border-white/10 bg-white/5 px-2 py-0.5 font-mono text-sm md:text-base" data-id="element-247" data-mp="ac509q92ris3">
              <span className="font-black text-[#00f0ff] drop-shadow-[0_0_5px_rgba(0,240,255,0.5)]" data-id="element-248" data-mp="2rudvmzzsnio">
                {formatNumber(minutes)}
              </span>
              <span className="text-white/30" data-id="element-249" data-mp="cqs36s58sl2q">:</span>
              <span className="font-black text-[#00f0ff] drop-shadow-[0_0_5px_rgba(0,240,255,0.5)]" data-id="element-250" data-mp="cqjqp1d17hs2">
                {formatNumber(seconds)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
function formatNumber(value: number) {
  return value.toString().padStart(2, '0');
}